import { select, spawn, fork, put, call, all } from "redux-saga/effects";
import initializeUserMetrics from "@tailormed/common-client/store/saga/services/userMetrics";
import { waitForLogin } from "@tailormed/common-client/store/saga/authSagas";
import { getAuthInstance } from "@tailormed/common-client/services/auth";
import { logout } from "@tailormed/common-client/services/auth";

import ACTION from "../action";
import { ApiNames } from "../../api/api";
import { selectIDPConfig, selectUser } from "../selector";
import { callApi } from "./networkActions";
import { watchSignInActions } from "./authActions";
import { oktaConfig } from "../../constant/okta";
import ErrorMessage from "../../component/customComponent/customMessages/ErrorMessage";
import { actions } from "./sagaActions";

function* getUser() {
  const loggedUserRes = yield callApi(ApiNames.LoggedUser);
  if (loggedUserRes) {
    const { data } = loggedUserRes;
    const { phiAllowed, siteLicense, users } = data;
    yield put(ACTION.setIsPhiAllowed(phiAllowed));
    yield put(ACTION.setEnvironment(siteLicense.siteName));
    yield put(ACTION.setTier(siteLicense.tier));
    yield put(ACTION.setUser(users[0]));
  } else {
    ErrorMessage(`User is not allowed`);
    const idpConfig = yield select(selectIDPConfig);
    const user = yield select(selectUser);
    yield call(logout, user, idpConfig, oktaConfig.loginURI);
  }
}

function* getSettings() {
  try {
    const settingsRes = yield callApi(ApiNames.Settings);
    if (settingsRes) {
      yield put(ACTION.setSettings(settingsRes.settings));
    }
  } catch (error) {
    ErrorMessage(`Failed to get settings: ${error}`);
  }
}

function* getFacilities() {
  const result = yield callApi(ApiNames.Providers, "facility");
  if (result) {
    yield put(ACTION.provider(result.providers));
  } else {
    ErrorMessage(`Failed to get providers data`);
  }
}

function* getAssignees() {
  const assigneesRes = yield callApi(ApiNames.Assignees);
  if (assigneesRes) {
    yield put(ACTION.setAssignees(assigneesRes.users));
  } else {
    ErrorMessage(`Failed to get assignees`);
  }
}

function* getUserGroups() {
  const result = yield callApi(ApiNames.UserGroups);
  if (result) {
    const userGroups = result["user-groups"].reduce(
      (groupMap, group) => Object.assign(groupMap, { [group.id]: group }),
      {}
    );
    yield put(ACTION.setUserGroups(userGroups));
  } else {
    ErrorMessage(`Failed to get user groups`);
  }
}

function* startup() {
  const oktaClientId = sessionStorage.getItem("oktaClientId");
  const oktaAuth = getAuthInstance(oktaConfig.redirectUri, oktaClientId);
  const token = oktaAuth.getAccessToken();
  yield put(ACTION.setTableauToken(token));
  yield all([call(getUser), call(getSettings), call(getFacilities), call(getAssignees), call(getUserGroups)]);
  yield spawn(initializeUserMetrics, { analytics: true, rum: true, token });
}

function* rootSaga() {
  yield fork(watchSignInActions);
  yield waitForLogin();
  yield fork(startup);
  yield spawn(actions);
}

export { rootSaga };
